// extracted by mini-css-extract-plugin
module.exports = {"test":"style_test__2OtOl","bg":"style_bg__37tFo","gallery":"style_gallery__1sw2M","gallery__wrap":"style_gallery__wrap__RBjLi"};